
import { COUNTRY_HOMEPAGE, PRICES, TUTORS, EN_DOWNLOAD, EN_BECOME_TUTORS, INVITE_FRIENDS, PERSONAL, LOGIN, FAQ, MAIN_HOME, ONE_ON_ONE, HAPPY_KIDS, PARTNER, } from 'constants/url';
import logOut from '../logout';
export type MenuItem = {
	icon?: string;
	eventId?: string;
	label: string;
	name: string;
	path?: string;
	parent?: string;
	login?: boolean;
	onClick?(props?: any): void;
	code?: string;
}

// 顺序不要改
export const MenuList: MenuItem[] = [
	{
		icon: 'icon_home',
		eventId: 'mainhome',
		label: '',
		name: 'home',
		path: MAIN_HOME,
	},
	{
		icon: 'icon_1on1',
		eventId: 'ACW_nav_1on1',
		label: '',
		name: 'one_on_one',
		path: ONE_ON_ONE,
	},
	{
		icon: 'icon_happykids',
		eventId: 'ACW_nav_happykids',
		label: '',
		name: 'happy_kids',
		path: HAPPY_KIDS,
	},
	{
		icon: 'icon_ourtutors',
		eventId: 'ACW_nav_ourtutor',
		label: '',
		name: 'our_tutors',
		path: TUTORS,

	},
	{
		icon: 'icon_howitwork',
		eventId: 'ACW_nav_prices',
		label: '',
		name: 'prices',
		path: PRICES,

	},
	{
		icon: 'icon_howitwork',
		eventId: 'ACW_nav_partner',
		label: '',
		name: 'partner',
		path: PARTNER,
	},
	{
		icon: 'icon_becomeatutor',
		eventId: 'ACW_nav_becomeatutor',
		label: '',
		name: 'become_a_tutor',
		path: EN_BECOME_TUTORS,
	},
	{
		icon: 'icon_download',
		eventId: 'ACW_nav_appdownload',
		label: '',
		name: 'app_download',
		path: EN_DOWNLOAD,
	},
	{
		icon: 'icon_invitegift',
		eventId: 'ACW_nav_invitegift',
		label: '',
		name: 'invite_gift',
		path: INVITE_FRIENDS,
		login: true,
	},
	{
		icon: 'icon_setting',
		eventId: 'ACW_nav_settings',
		label: '',
		name: 'setting',
		path: PERSONAL,
		login: true,
	},
	{
		icon: 'icon_faqs',
		eventId: 'ACW_nav_faq',
		label: '',
		name: 'faq',
		path: FAQ,
		// login: false,
	},
	{
		icon: 'icon_logout',
		eventId: 'ACW_nav_logout',
		label: '',
		name: 'logout',
		login: true,
		onClick: logOut,
	},
	{
		icon: 'icon_login',
		eventId: 'ACW_nav_login',
		label: '',
		name: 'login',
		path: LOGIN,
		login: false,
	},
];

export const HomeMenus: MenuItem[] = [
	{
		icon: 'icon_home',
		eventId: 'mainhome',
		label: '',
		name: 'main_home',
		path: MAIN_HOME,
	},
];
